export default "__VITE_ASSET__f65b9166__"